import { put, select, call, fork, takeLatest, all } from "redux-saga/effects";
import { surveysApiUpsellProvider, surveyApiUpsellProvider } from "../../lib/api/providers";

import {
  SURVEY_SET_CURRENT_FILTERS,
  SURVEY_GET_DYNAMIQUE_FILTER_VALUES,
  SURVEY_SET_FILTERS,
  SURVEY_SET_PAGINATION,
  GET_SURVEY_LIST,
  SET_SURVEY_LIST,
  SET_KEY_SURVEY_FILTER_SELECTED,
  SET_SURVEY_SORT,
  GET_ARCHIVE_SURVEY,
  SET_ARCHIVE_SURVEY,
  SURVEY_DELETE
} from "../types";
import { getCurrentDashboardData } from "../../modules/stats/selectors";
import { tokenSelector } from "../selectors/auth";
import { setListLoading } from "../actions/surveyActions";

const getSurveyState = state => state.survey.surveyManager;

const getState = state => state;

const getSurveyApi = state => {
  const { keySortSelected, surveySort, keyFilterSelected, currentFilters, page, pageSize } = state.survey.surveyManager;
  const getSortObject = { [keySortSelected]: surveySort, updated_at: -1 };

  return surveysApiUpsellProvider
    .post(`/`, {
      key: keyFilterSelected,
      sort: getSortObject,
      match: { ...currentFilters, client_id: state.currentClient.id },
      page: page > 0 ? page : 1,
      pageSize: pageSize
    })
    .then((response = {}) => {
      return response.data;
    });
};

const getFiltersValuesApi = (state, clientId) => {
  const { keyFilterSelected } = state;
  const apiPath =
    keyFilterSelected === "SurveyPeriodicity"
      ? "/range/SurveyPeriodicity.startDate/SurveyPeriodicity.endDate"
      : `/distincts/${keyFilterSelected}`;

  return surveysApiUpsellProvider
    .post(apiPath, {
      key: state.keyFilterSelected,
      match: { ...state.currentFilters, client_id: clientId }
    })
    .then((response = {}) => {
      return response.data;
    });
};

const getSurveyArchiveValuesApi = key => {
  return surveyApiUpsellProvider.post("/archive", key.surveyId).then((response = {}) => {
    return response.data;
  });
};

const deleteSurveyApi = (token, id) => {
  return surveyApiUpsellProvider.post(
    "/delete",
    { id },
    {
      headers: {
        Authorization: token
      }
    }
  );
};

function* setArchiveSurvey(key) {
  try {
    const data = yield call(getSurveyArchiveValuesApi, key);

    yield put({ type: SET_ARCHIVE_SURVEY, payload: data });
  } catch (e) {
    console.log(e.message);
  }
}

function* getSurvey() {
  try {
    const state = yield select(getState);
    yield put(setListLoading(true));
    const data = yield call(getSurveyApi, state);

    if (!Array.isArray(data.docs)) throw new Error("No survey");
    yield put({ type: SET_SURVEY_LIST, payload: data });
    yield put(setListLoading(false));
  } catch (e) {
    console.log(e.message);
    yield put(setListLoading(false));
  }
}

function* getFilterValues() {
  try {
    const state = yield select(getSurveyState);
    const globalState = yield select(getState);
    const currentClientId = globalState.currentClient ? globalState.currentClient.id : null;
    const values = yield call(getFiltersValuesApi, state, currentClientId);

    if (!values) throw new Error("No survey");

    yield put({ type: SURVEY_SET_FILTERS, filters: values });
  } catch (e) {
    console.log(e.message);
  }
}

function* deleteSurvey({ id }) {
  try {
    const token = yield select(tokenSelector);
    yield put(setListLoading(true));
    yield call(deleteSurveyApi, token, id);
    yield call(getSurvey, token, id);
    yield put(setListLoading(false));
    //yield put({ type: SET_ARCHIVE_SURVEY, payload: data });
  } catch (e) {
    console.log(e.message);
    yield put(setListLoading(false));
  }
}

function* watchFetchDynFilterValues() {
  yield takeLatest(SURVEY_GET_DYNAMIQUE_FILTER_VALUES, getFilterValues);
}

function* watchFetchSurveyPagination() {
  yield takeLatest(SURVEY_SET_PAGINATION, getSurvey);
}

function* watchFetchFiltersSelected() {
  yield takeLatest(SURVEY_SET_CURRENT_FILTERS, getSurvey);
}

function* watchFetchGetSurveyList() {
  yield takeLatest(GET_SURVEY_LIST, getSurvey);
}

function* watchSetKeyFilterSelected() {
  yield takeLatest(SET_KEY_SURVEY_FILTER_SELECTED, getFilterValues);
}

function* watchSetSurveySort() {
  yield takeLatest(SET_SURVEY_SORT, getSurvey);
}

function* watchSetArchiveSurvey() {
  yield takeLatest(GET_ARCHIVE_SURVEY, setArchiveSurvey);
}

function* watchDeleteSurvey() {
  yield takeLatest(SURVEY_DELETE, deleteSurvey);
}

export default function* root() {
  yield all([
    fork(watchSetKeyFilterSelected),
    fork(watchFetchGetSurveyList),
    fork(watchFetchDynFilterValues),
    fork(watchFetchSurveyPagination),
    fork(watchFetchFiltersSelected),
    fork(watchSetSurveySort),
    fork(watchSetArchiveSurvey),
    fork(watchDeleteSurvey)
  ]);
}



// WEBPACK FOOTER //
// src/redux/sagas/surveySagas.js